//@ts-nocheck
export function brandGridFunctions() {
    passBrandWhenOpenBtnClicked();
    closeBtnClickHandler();
}




export function passBrandWhenOpenBtnClicked() {
    const openBtns: NodeListOf<HTMLButtonElement> = document.querySelectorAll(
        ".snippet-brands-grid__open-btn"
    );
    openBtns.forEach((openBtn) => {
        openBtn.addEventListener("click", () => {
            const brand: HTMLDivElement = openBtn?.closest(
                ".snippet-brands-grid__brand"
            );

            asgincontentToModal(brand);
        });
    });
}

export function asgincontentToModal(brand: HTMLDivElement) {
    const grid: HTMLDivElement = brand?.closest(".snippet-brands-grid");
    const modal: HTMLDivElement = grid?.querySelector(
        ".snippet-brands-grid__modal"
    );
    const brandcontent: HTMLDivElement = brand?.querySelector(
        ".snippet-brands-grid__content-body"
    );
    const modelContentContainer: HTMLBodyElement = modal?.querySelector(
        ".snippet-brands-grid__modal-content-container"
    );

    if (!brandcontent || !modelContentContainer || !modal || !grid) {
        console.error(
            "The structure of this snippet is not correct as key elements are missing, please check the snippet structure with a another version from the cms and copy the correct structure accross."
        );
        return;
    }

    modelContentContainer.innerHTML = brandcontent.innerHTML;
    modal.classList.add("snippet-brands-grid__modal--active");
    document.body.classList.add("nav-open");
}

export function closeBtnClickHandler() {
    const closeBtns: NodeListOf<HTMLButtonElement> = document.querySelectorAll(
        ".snippet-brands-grid__close-btn"
    );
    closeBtns.forEach((closeBtn) => {
        closeBtn.addEventListener("click", () => {
            const grid: HTMLDivElement = closeBtn?.closest(
                ".snippet-brands-grid"
            );
            const modal: HTMLDivElement = grid?.querySelector(
                ".snippet-brands-grid__modal"
            );

            if (!modal || !grid) {
                console.error(
                    "The structure of this snippet is not correct as key elements are missing, please check the snippet structure with a another version from the cms and copy the correct structure accross."
                );
                return;
            }

            modal.classList.remove("snippet-brands-grid__modal--active");
            document.body.classList.remove("nav-open");
        });
    });
}
